import { formatTenThousandths, parseTenThousandths } from './moneyArithmetic';

const PERCENT_DIVISOR = 100n;
const MAX_PERCENT_TEN_THOUSANDTHS = 999_900n;

/** Converts a VAT percentage (`"20.0000"`) to the four-place fraction vat.ts takes (`"0.2000"`); null when absent, inexact or above 99.99. */
export const vatFractionFromPercent = (percent: string | null | undefined): string | null => {
    if (percent === null || percent === undefined) {
        return null;
    }
    const tenThousandths = parseTenThousandths(percent);
    if (
        tenThousandths === null ||
        tenThousandths < 0n ||
        tenThousandths > MAX_PERCENT_TEN_THOUSANDTHS ||
        tenThousandths % PERCENT_DIVISOR !== 0n
    ) {
        return null;
    }
    return formatTenThousandths(tenThousandths / PERCENT_DIVISOR);
};
